import dayjs, { Dayjs } from 'dayjs';
import { SHOW_ORDER_DATE_FORMAT } from '../constants/order';

export const hasEmptyText = (value: string | number | undefined | null) => {
  if (value === undefined || value === null || value === '') {
    return '-';
  }
  return value;
};

export const intersperse = (
  values: Array<string | undefined | null | number>,
  seperator: string,
) => {
  const filteredValues: Array<string | number> = [];
  values.forEach((e) => {
    if (e !== undefined && e !== null) {
      filteredValues.push(e);
    }
  });
  return filteredValues.join(seperator);
};

export const getDateString = (start: number | null | undefined, end: number | null | undefined) => {
  const startDate = dayjs.unix(start as number) as Dayjs;
  const endDate = dayjs.unix(end as number) as Dayjs;
  if (!startDate.isValid() || !endDate.isValid()) {
    return '-';
  }
  if (startDate.year() === endDate.year())
    return `${startDate.format('DD')} ${startDate.format('MMM')} - ${endDate.format(
      'DD',
    )} ${endDate.format('MMM')} ${endDate.format('YYYY')} `;
  return `${startDate.format('DD')} ${startDate.format('MMM')} ${startDate.format(
    'YYYY',
  )} - ${endDate.format('DD')} ${endDate.format('MMM')} ${endDate.format('YYYY')} `;
};

export const getDateStringInDayMonthYearFormat = (
  start: number | null | undefined,
  end: number | null | undefined,
) => {
  const startDate = dayjs(start as number) as Dayjs;
  const endDate = dayjs(end as number) as Dayjs;

  if (!startDate.isValid() || !endDate.isValid()) {
    return '-';
  }

  return `${startDate.format(SHOW_ORDER_DATE_FORMAT)} - ${endDate.format(SHOW_ORDER_DATE_FORMAT)}`;
};

export const getDateDiffString = (
  start: number | null | undefined,
  end: number | null | undefined,
) => {
  const startDate = dayjs.unix(start as number) as Dayjs;
  const endDate = dayjs.unix(end as number) as Dayjs;
  if (!startDate.isValid() || !endDate.isValid()) {
    return '-';
  }
  const differenceInDays = endDate.diff(startDate, 'day') + 1;
  return `${differenceInDays} Day${differenceInDays > 1 ? 's' : ''}`;
};

export const getFormattedDate = (timestamp: number | null | undefined): string => {
  const date = dayjs(timestamp as number) as Dayjs;

  if (!date.isValid()) {
    return '-';
  }

  return `${date.format(SHOW_ORDER_DATE_FORMAT)}`;
};

export const getFormattedDateFromString = (dateString: string): string => {
  const date = new Date(dateString);

  const month = date.toLocaleString('en-US', { month: 'short' });
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month} ${day}, ${year}`;
};
